import {DiagramVersion, DiagramVersionJSON} from 'src/app/shared/models/diagram-version.interface';
import {ConnectorLinkData} from 'src/app/shared/models/connector-link.interface';
import {ConnectorTargetId} from 'src/app/shared/models/connector-target-id.interface';

export class ConnectorLink implements ConnectorLinkData {
  public diagramVersion: DiagramVersion;
  public connector: ConnectorTargetId = {
    id: undefined
  };
  public flowline: ConnectorTargetId = {
    id: undefined
  };

  constructor(json?: DiagramVersionJSON) {
    if (json) {
      const {
        id,
        title,
        mapName,
        diagramId,
        levelNumber,
        team: {id: spaceId}
      } = json;

      this.diagramVersion = {id, title, mapName, diagramId, levelNumber, spaceId};
    }
  }
}
